import { CommonModule } from '@angular/common';
import { Component, output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogConfig, DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { ReferentialsUnitsService } from '../referentials-units.service';
import { MessageService } from 'primeng/api';
import { GenericErrorResponse } from '../../../../../core/models/generic-response.model';
import { Subject } from 'rxjs';
import { InlineResponse } from '../../../../../core/models/inline-response.model';
import { Unites } from '../unites.model';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { ToastModule } from 'primeng/toast';
import { provideTranslocoScope, TranslocoModule, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-add-unit',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule, DynamicDialogModule, InputTextModule, InputGroupModule, InputGroupAddonModule, ConfirmDialogModule, ReactiveFormsModule, ProgressSpinnerModule, CardModule, MessagesModule, MessageModule, ToastModule, TranslocoModule],
  providers: [MessageService, provideTranslocoScope({ scope: 'referentiels' })],
  templateUrl: './add-unit.component.html',
  styleUrl: './add-unit.component.css',
})
export class AddUnitComponent {
  private destroy$: Subject<boolean> = new Subject<boolean>();

  uniteFormArray!: FormArray;
  fg!: FormGroup;
  errors: GenericErrorResponse[] = [];
  submitting: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private messageService: MessageService,
    private unitesServices: ReferentialsUnitsService,
    private translocoService: TranslocoService
  ) {}

  uniteForm = this.formBuilder.group({
    codeCourt: ['', [Validators.required, Validators.maxLength(3)]],
    codeHecate: ['', [Validators.required, Validators.maxLength(10), Validators.pattern('^[0-9]*$')]],
    designation: ['', [Validators.required, Validators.maxLength(20)]],
  });

  userHasReadWritePermission: boolean = false;

  ngOnInit(): void {
    if (!!this.config.data) {
      this.fg = this.config.data.uniteForm;
      this.uniteFormArray = this.fg.get('uniteFormArray') as FormArray;
      this.userHasReadWritePermission = this.config.data.userHasReadWritePermission;
    }
  }

  addUnites() {
    this.submitting = true;

    this.unitesServices.addUnitesData(this.uniteForm.get('codeCourt')?.value ?? '', Number(this.uniteForm.get('codeHecate')?.value), this.uniteForm.get('designation')?.value ?? '').subscribe({
      next: (data) => {
        this.checkIfTypePrestationSuccessfull(data);
        this.submitting = false;
      },
      error: (error) => {
        this.messageService.add({ severity: 'error', summary: this.translocoService.translate('error.popup.titre.defaut'), detail: 'Une erreur est survenue ' + this.errors.map((e) => e.errorMsg), life: 3000 });
      },
    });
  }

  private checkIfTypePrestationSuccessfull(data: InlineResponse) {
    switch (data.success) {
      case true:
        let unite = data.object as Unites;
        this.uniteFormArray.push(
          this.formBuilder.group({
            id: [unite.id],
            codeHecate: [unite.codeHecate],
            designation: [unite.designation],
            afficherSurLaConfirmation: [unite.codeCourt],
          }),
        );
        this.close(true);
        break;
      case false:
        this.errors = data.errors.length > 0 ? data.errors : [data.exception];
        this.messageService.add({ severity: 'error', summary: this.translocoService.translate('error.popup.titre.defaut'), detail: 'Une erreur est survenue ' + this.errors.map((e) => e.errorMsg), life: 3000 });
        break;
    }
  }

  close(result: boolean): void {
    this.ref.close(result);
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
